module.exports = __webpack_public_path__ + "img/LTE:OK - WLAN:OK.fe0bc281.jpg";